export default class ManageAccessListNodeService {
  constructor ($timeout, AccessListService) {
    'ngInject'
  }
}
